import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {FeedbackProvider} from './components/FeedbackProvider';
import reportWebVitals from './reportWebVitals';
import {installSessionExpiryGuard} from './api';
import {initAnalytics} from './analytics';

installSessionExpiryGuard();
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FeedbackProvider>
      <App />
    </FeedbackProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
